import { render, staticRenderFns } from "./AccessButton.vue?vue&type=template&id=49603adc"
import script from "./AccessButton.vue?vue&type=script&lang=js"
export * from "./AccessButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports